import React from 'react';
import { Text, ButtonLink } from '../index';
import modalLockImage from '../Modal/ModalLockImage.jpg';
import routes from '../../constants/routes';

interface SubscriptionModalProps {
  /** Nadpis – bez props zůstává původní text pro Rejstříky. */
  title?: string;
  /** Popis funkce („marketingový" text konkrétního modulu). */
  text?: string;
  /** Tlačítko Objednat – skrýt pro membery (licenci kupuje budova, member žádá výbor). */
  showOrderButton?: boolean;
}

export const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
  title = 'Narazili jste na placenou funkci aplikace',
  text = 'Zjištěné změny týkající se vašeho domu, společenství, vlastníků jednotek a společností se sídlem na adrese ve vašem domě je možné zobrazit pouze po zaplacení plné verze aplikace. V plné verzi aplikace provádíme kontroly častěji a automaticky vás budeme o zjištěných změnách a problémech informovat!',
  showOrderButton = true,
}) => {
  return (

    <div className="ModalLock">
      <div className="Modal__inner">
        <div className="Modal__content">
          <img src={modalLockImage} alt="" className="ModalLock__image mb-4" />
          <Text align="center" size="h2" color="Neutral700" className="mb-3">
            {title}
          </Text>
          <Text align="center" color="Neutral700" className="mb-2">
            {text}
          </Text>
          {showOrderButton && <ButtonLink to={routes.subscriptionOrder} title="Objednat" />}
        </div>
      </div>
    </div>
  );
};
